<script lang="ts">
	import { page } from '$app/state';
	import { getCountryDisplayName, getFlagEmoji } from '$lib';
	import { slide } from 'svelte/transition';

	const { siblings, currentCountry }: { siblings: Config['siblings']; currentCountry: string } =
		$props();

	let open = $state(false);
</script>

{#if siblings.length > 1}
	<span class="ml-0.5 h-6 w-6 self-start">{getFlagEmoji(currentCountry)}</span>
	<div class="flex flex-col text-xs">
		<button
			onclick={() => (open = !open)}
			class="mb-1.5 flex items-center gap-2 text-sm capitalize"
		>
			<span>{getCountryDisplayName(currentCountry, page.data.store.language)}</span>
			<span class={['icon-[mdi--chevron-down] text-lg transition', { 'rotate-180': open }]}></span>
		</button>

		{#if open}
			<div class="flex flex-col gap-2" transition:slide>
				{#each siblings as config (config.locale)}
					{@const [lang, country] = config.locale.split('_')}
					{#if country !== currentCountry}
						<a
							href={config.base_url}
							class="flex items-center gap-3 border-b border-b-neutral-600 py-2 text-sm capitalize"
							rel="noopener noreferrer"
						>
							<span>{getFlagEmoji(country)}</span>
							<span>{getCountryDisplayName(country, lang)}</span>
						</a>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
{/if}
